import { Phone, MapPin } from "lucide-react";
import { NAV_LINKS, CONTENT, telHref } from "../data/site";
import { scrollToSection } from "./Header";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505] px-6 py-16 md:px-12">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 md:grid-cols-3">
      <div>
        <div className="flex items-center">
          <span className="flex items-center rounded-md bg-white px-2.5 py-1.5">
            <img src="/logo.png" alt="Renuka Roofing Structurals" className="h-12 w-auto" />
          </span>
        </div>
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#A3A3A3]">
          Structural fabrication, roofing solutions, structural design and prefabricated houses — engineered for
          strength, built for life.
        </p>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Navigate</p>
        <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => scrollToSection(l.href)}
              className="text-left text-sm text-[#A3A3A3] transition-colors hover:text-[#3377FF]"
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Contact</p>
        <a
          data-testid="footer-phone-link"
          href={telHref()}
          className="mt-5 flex items-center gap-2 text-sm text-[#A3A3A3] transition-colors hover:text-[#3377FF]"
        >
          <Phone size={14} className="text-[#3377FF]" /> {CONTENT.phone}
        </a>
        <p className="mt-3 flex items-start gap-2 text-sm text-[#A3A3A3]">
          <MapPin size={14} className="mt-0.5 shrink-0 text-[#3377FF]" /> {CONTENT.address}
        </p>
      </div>
    </div>
    <div className="mx-auto mt-14 flex max-w-7xl flex-col gap-2 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
      <span>© 2026 Renuka Roofing Structurals. All rights reserved.</span>
      <span>Gopanapally · Hyderabad · Telangana</span>
    </div>
  </footer>
);
